import './tooltip.scss';

const Tooltip = ({ content, aria, children }: { content: string, aria: string, children: JSX.Element }) => {

    return (
        <>
            <span className="helper" role="tooltip" tabIndex={0} aria-describedby={aria}>
                {children}
                <span className="tooltip">
                    {content}
                </span>
            </span>
        </>
    );
};

export default Tooltip;